<template>
  <span>
    <div @click.stop="showModal">
      <slot></slot>
    </div>
    <Modal
        title="员工信息查看"
        v-model="visible"
        width="800"
    >
      <div class="staff-container">
        <div class="staff-info">
          <div class="image-content">
            <div class="avatar" :style="avatarStyle">
              <span>{{staffInfo.avatar ? '' : '暂无'}}</span>
            </div>
          </div>
          <div class="text-content">
            <div class="left">
              <Row>
                <i-col v-bind="labelCol" class="staff-key">姓名：</i-col>
                <i-col v-bind="wrapperCol" class="staff-value">{{staffInfo.name}}</i-col>
              </Row>
              <Row>
                <i-col v-bind="labelCol" class="staff-key">性别：</i-col>
                <i-col v-bind="wrapperCol" class="staff-value">{{{ 1: '男', 2: '女' }[staffInfo.sex]}}</i-col>
              </Row>
              <Row>
                <i-col v-bind="labelCol" class="staff-key">证件号：</i-col>
                <i-col v-bind="wrapperCol" class="staff-value">{{staffInfo.idNo}}</i-col>
              </Row>
              <Row>
                <i-col v-bind="labelCol" class="staff-key">手机号：</i-col>
                <i-col v-bind="wrapperCol" class="staff-value">{{staffInfo.mobile}}</i-col>
              </Row>
              <Row>
                <i-col v-bind="labelCol" class="staff-key">邮箱：</i-col>
                <i-col v-bind="wrapperCol" class="staff-value">{{staffInfo.email}}</i-col>
              </Row>
              <Row>
                <i-col v-bind="labelCol" class="staff-key">E卡号：</i-col>
                <i-col v-bind="wrapperCol" class="staff-value">{{staffInfo.acNo}}</i-col>
              </Row>
              <Row>
                <i-col v-bind="labelCol" class="staff-key">所属社区：</i-col>
                <i-col v-bind="wrapperCol" class="staff-value">{{staffInfo.spaceName}}</i-col>
              </Row>
            </div>
            <div class="right">
              <Row>
                <i-col v-bind="labelCol" class="staff-key">所属企业：</i-col>
                <i-col v-bind="wrapperCol" class="staff-value">{{staffInfo.companyName}}</i-col>
              </Row>
              <Row>
                <i-col v-bind="labelCol" class="staff-key">部门：</i-col>
                <i-col v-bind="wrapperCol" class="staff-value">{{staffInfo.deptName}}</i-col>
              </Row>
              <Row>
                <i-col v-bind="labelCol" class="staff-key">职位技能：</i-col>
                <i-col v-bind="wrapperCol" class="staff-value">{{staffInfo.skill}}</i-col>
              </Row>
              <Row>
                <i-col v-bind="labelCol" class="staff-key">身份证：</i-col>
                <i-col v-bind="wrapperCol" class="staff-value">
                  <div class="id-card" :style="idCardStyle">
                    <span>{{staffInfo.idCardPhoto ? '' : '暂无'}}</span>
                  </div>
                </i-col>
              </Row>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="staff-bottom">
        <h3>更新时间：{{staffInfo.updateTime || '暂无'}}</h3>
        <div class="button-content">
          <Button type="primary" @click="edit">确定</Button>
          <Button @click="handleCancel">取消</Button>
        </div>
      </div>
    </Modal>
  </span>
</template>

<script>
  export default {
    name: 'DisplayStaff',
    props: {
      userId: [Number, String]
    },
    data () {
      return {
        visible: false,
        staffInfo: {
          name: null,
          sex: null,
          idNo: null,
          mobile: null,
          acNo: null,
          spaceName: null,
          deptName: null,
          skill: null,
          avatar: '',
          idCardPhoto: '',
          companyName: '',
          updateTime: ''
        },
        labelCol: {
          span: '7'
        },
        wrapperCol: {
          span: '16',
          offset: '1'
        }
      }
    },
    computed: {
      avatarStyle () {
        return {
          backgroundImage: `url(${this.staffInfo.avatar})`
        }
      },
      idCardStyle () {
        return {
          backgroundImage: `url(${this.staffInfo.idCardPhoto})`
        }
      }
    },
    methods: {
      showModal () {
        this.visible = true;
        let userId = this.userId;
        this.$get(`/customer/company/${userId}`).then((res) => {
          if (res.success) {
            for (let item in this.staffInfo) {
              this.staffInfo[item] = res.data[item];
            }
          }
        })
      },
      edit () {
        this.$emit('editStaff');
      },
      handleCancel () {
        this.visible = false;
      }
    }
  }
</script>

<style lang="less" scoped>
  .staff-container{
    font-size: 14px;
    color: #000000;
    .staff-info{
      margin: 10px 0;
      display: flex;
      .image-content{
        display: flex;
        flex-direction: column;
        .avatar{
          width: 100px;
          height: 100px;
          background-size: cover;
          cursor: pointer;
          background-color: #DFF3FF;
          text-align: center;
          color: #949494;
          line-height: 100px;
        }
        .id-card{
          width: 150px;
          height: 100px;
          background-size: cover;
          cursor: pointer;
          margin-top: 20px;
          background-color: #DFF3FF;
          text-align: center;
          color: #949494;
          line-height: 100px;
        }
      }
      .text-content{
        display: flex;
        flex: 3;
        line-height: 2.5;
        .staff-key{
          text-align: right;
        }

        .left{
          flex: 2;
        }
        .right{
          flex: 3;
          .id-card{
            width: 150px;
            height: 100px;
            background-size: cover;
            cursor: pointer;
            background-color: #DFF3FF;
            text-align: center;
            color: #949494;
            line-height: 100px;
          }
        }
      }
    }
  }
  .staff-bottom{
    h3{
      font-size: 12px;
      color: #797979;
      text-align: left;
    }
    .button-content{
      text-align: center;
    }
  }
</style>
